/** 应急预案静态菜单：二级分类 + 预案项，均跳转同一 demo 页（query.code 区分） */
export const EMERGENCY_PLAN_DEMO_PATH = '/pages/emergency/emergencyPlanDemo'

/** 三级预案 code -> 展示名称（供 demo 页等使用） */
export const EMERGENCY_PLAN_CODE_TO_TITLE = {}

function epChild(name, code, seq) {
  EMERGENCY_PLAN_CODE_TO_TITLE[code] = name
  return {
    name,
    href: `${EMERGENCY_PLAN_DEMO_PATH}?code=${encodeURIComponent(code)}`,
    isShow: 'Y',
    seq
  }
}

const EMERGENCY_PLAN_GROUPS = [
  {
    id: 'ep_natural',
    name: '自然灾害',
    icon: 'fa-cloud',
    seq: 1,
    childs: [
      epChild('台风红色预警停业避险预案', 'natural_typhoon_red', 1),
      epChild('洪涝灾害地下空间防控预案', 'natural_flood_underground', 2),
      epChild('雷击事故实验室设备防护预案', 'natural_lightning_lab', 3),
      epChild('地震应急疏散及避难预案', 'natural_earthquake_evacuation', 4),
      epChild('持续强降雨内涝排水预案', 'natural_heavy_rain_drainage', 5)
    ]
  },
  {
    id: 'ep_accident',
    name: '事故灾难',
    icon: 'fa-fire-extinguisher',
    seq: 2,
    childs: [
      epChild('物业初起火灾扑救预案', 'accident_fire_initial', 1),
      epChild('机房灭火专项预案', 'accident_server_room_fire', 2),
      epChild('危化品泄漏火灾联动预案', 'accident_chemical_leak_fire', 3),
      epChild('机房、厨房爆炸事故处置预案', 'accident_explosion_room_kitchen', 4),
      epChild('园区电网瘫痪应急供电预案', 'accident_grid_blackout_power', 5)
    ]
  },
  {
    id: 'ep_public_health',
    name: '公共卫生',
    icon: 'fa-medkit',
    seq: 3,
    childs: [
      epChild('群体性食物中毒响应预案', 'public_food_poisoning', 1),
      epChild('传染病暴发封控管理预案', 'public_infectious_outbreak', 2),
      epChild('饮用水污染紧急处置预案', 'public_drinking_water', 3)
    ]
  },
  {
    id: 'ep_social_security',
    name: '社会安全',
    icon: 'fa-shield',
    seq: 4,
    childs: [
      epChild('大门冲岗应急处置预案', 'security_gate_rush', 1),
      epChild('群体聚集事件疏导预案', 'security_gathering_crowd', 2),
      epChild('社区危机公关预案', 'security_community_pr', 3),
      epChild('反恐防暴协同处置预案', 'security_anti_terror', 4)
    ]
  },
  {
    id: 'ep_support',
    name: '综合保障',
    icon: 'fa-cubes',
    seq: 5,
    childs: [
      epChild('应急物资智能调度预案', 'support_material_dispatch', 1),
      epChild('商户群体性事件应急处理预案', 'support_merchant_incident', 2),
      epChild('三大业态联动应急支援预案', 'support_triple_business_linkage', 3)
    ]
  }
]

export function buildEmergencyPlansMenuTree() {
  return JSON.parse(JSON.stringify(EMERGENCY_PLAN_GROUPS))
}
